import Axios from 'axios';
import { toast } from 'react-toastify';

import { env } from '@/app/conf/env';
import { getUser } from '@/shared/auth';

export const api = Axios.create({
  baseURL: `${env.API_URL?.replace(/\$/, '')}/tenants/1`,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const { access_token } = getUser() ?? {};

  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }

  return config;
});

api.interceptors.response.use(
  response => response.data,
  (error) => {
    // Show toast notification for errors
    const message = error.response?.data?.message || error.message;
    toast.error(message, { autoClose: false });

    // if (error.response.status === 401) {
    //   const searchParams = new URLSearchParams();
    //   const redirectTo = searchParams.get('redirectTo') || window.location.pathname;
    //   window.location.href = `/auth/login?redirectTo=${redirectTo}`;
    // }

    return Promise.reject(error);
  }
);
